import { Class } from '@mui/icons-material';
import React, { useState, useEffect } from 'react';


function Instock() {
  const [heading, setHeading] = useState('');
  const [material, setMaterial] = useState('');
  const [Class, setClass] = useState('');
  const [BrandName, setBrandName] = useState('');
  const [quantity, setQuantity] = useState('');
  const [peritem, setPerItem] = useState('');
  const [provider, setprovider] = useState('');
  const [tamount, setTamount] = useState('');
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [remark, setRemark] = useState('');
  const [headings, setHeadings] = useState([]);
  const [newHeading, setNewHeading] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [saving, setSaving] = useState(false);
  const [data, setData] = useState({});
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [editingKey, setEditingKey] = useState(null);
  const [filteredData, setFilteredData] = useState({});
  const [schoolName, setSchoolName] = useState("");
  const [taluka, setTaluka] = useState("");
  const [jilha, setJilha] = useState("");
  const [logoURL, setLogoURL] = useState(null);
  const [VoucherNumber, setVoucherNumber] = useState('');
  const [ExpiryDate, setExpiryDate] = useState('');
  const [productId, setProductId] = useState('');
  const language =  localStorage.getItem("language") || "English";
  const [showModal, setShowModal] = useState(true);
  const [openRow, setOpenRow] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  const [serialNo, setSerialNo] = useState('');

  
    useEffect(() => {
      // Get today's date
      const today = new Date();
      const formattedDate = today.toISOString().split('T')[0]; // Format to yyyy-MM-dd
      setDate(formattedDate); // Set the default date
    }, []);
    
  useEffect(() => {
    // Calculate Total Amount when Quantity or Per Item Amount changes
    if (quantity && peritem) {
      const total = parseFloat(quantity) * parseFloat(peritem);
      setTamount(total);
    }
  }, [quantity, peritem]);
  
  useEffect(() => {
    // Calculate Per Item Amount when Total Amount and Quantity changes
    if (tamount && quantity) {
      const perItemAmount = parseFloat(tamount) / parseFloat(quantity);
      setPerItem(perItemAmount);
    }
  }, [tamount, quantity]);

  const addNewHeading = () => {
    if (newHeading.trim() !== "") {
      setHeadings(prevHeadings => [...prevHeadings, newHeading]);
      setHeading(newHeading);
      setShowPopup(false);
    }
  };


  const toggleRow = (key) => {
    setOpenRow(openRow === key ? null : key);
  };

  const openDatabase = async () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1);
  
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        // Create object stores if they don't exist
        if (!db.objectStoreNames.contains('inventory')) {
          const store = db.createObjectStore('inventory', { keyPath: 'id' });
          store.createIndex('key', 'key', { unique: false });
        }
      };
  
      request.onsuccess = (event) => {
        resolve(event.target.result);
      };
  
      request.onerror = (event) => {
        reject(event.target.error);
      };
    });
  };
  
  const fetchInStockData = async () => {
    const db = await openDatabase();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction('inventory', 'readonly');
      const store = transaction.objectStore('inventory');
      const request = store.get('instock'); // Fetch the 'instock' key
  
      request.onsuccess = (event) => {
        const result = event.target.result;
        console.log("result",result);
        
        if (result) {
          resolve(result.value); // Return the value array
        } else {
          resolve([]); // Return an empty array if not found
        }
      };
  
      request.onerror = (event) => {
        reject(event.target.error);
      };
    });
  };
 
  const handleUpdate = async (event) => {
    event.preventDefault();
  
    if (!isUpdate) {
      if (!date || !material || !heading) {
        alert("Please fill in Date, Material, and Heading.");
        return;
      }
    }
  
    setSaving(true);
    const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/inventory/instock.json`;
  
    try {
      // Fetch existing inventory data
      const response = await fetch(url, { method: 'GET' });
      let data = await response.json();
  
      // Ensure data is always an object, even if returns null
      if (!data || typeof data !== 'object') {
        data = {};
      }
  
      // Update the existing entry
      if (data[productId] && data[productId][serialNo]) {
        data[productId][serialNo] = {
          date: date || data[productId][serialNo].date,
          ExpiryDate: ExpiryDate || data[productId][serialNo].ExpiryDate,
          PerItemAmount: peritem || data[productId][serialNo].PerItemAmount,
          Quantity: quantity || data[productId][serialNo].Quantity,
          Remark: remark || data[productId][serialNo].Remark,
          VoucherNumber: VoucherNumber || data[productId][serialNo].VoucherNumber,
          provider: provider || data[productId][serialNo].provider,
          TotalAmount: tamount || data[productId][serialNo].TotalAmount,
          BrandName: BrandName || data[productId][serialNo].BrandName, // Update the BrandName field
          Heading: heading || data[productId].Heading,
          Material: material || data[productId].Material,
        };
  
        // Update the TotalQuantity field
        const totalQuantity = Object.values(data[productId])
          .filter(entry => typeof entry === 'object' && entry.Quantity)
          .reduce((sum, entry) => sum + Number(entry.Quantity), 0);
        data[productId].TotalQuantity = totalQuantity;
  
        // Save updated data to
        const updateResponse = await fetch(url, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        });
  
        if (updateResponse.ok) {
          setSaving(false);
  
          // Reset form fields
          setHeading('');
          setMaterial('');
          setEditingKey(null);
          setBrandName('');
          setExpiryDate('');
          setDate('');
          setprovider('');
          setVoucherNumber('');
          setQuantity('');
          setPerItem('');
          setTamount('');
          setIsUpdate(false);
          setRemark('');
  
          // Fetch updated data and update state
          const newResponse = await fetch(url, { method: 'GET' });
          const newData = await newResponse.json();
          setData(newData);
  
          // Update IndexedDB data
          const db = await openDatabase();
          const transaction = db.transaction('inventory', 'readwrite');
          const store = transaction.objectStore('inventory');
          const request = store.get('instock');
  
          request.onsuccess = async (event) => {
            const result = event.target.result;
            if (result) {
              const updatedData = { ...result.value };
              updatedData[productId] = data[productId];
              const request = store.put({
                key: 'instock',
                value: updatedData
              });
  
              request.onsuccess = () => {
                console.log('IndexedDB data updated successfully');
              };
  
              request.onerror = (event) => {
                console.error('Error updating IndexedDB data:', event.target.error);
              };
            }
          };
  
          request.onerror = (event) => {
            console.error('Error fetching IndexedDB data:', event.target.error);
          };
        } else {
          console.error('Error saving data:', updateResponse.statusText);
          setSaving(false);
        }
      } else {
        console.error(`Invalid product ID or serial number: ${productId} ${serialNo}`);
      }
    } catch (error) {
      console.error('Error saving data:', error);
      setSaving(false);
    }
  };
 
    const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0'); 
    const month = String(d.getMonth() + 1).padStart(2, '0'); 
    const year = d.getFullYear(); 
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchInStockData();
      
        console.log("data", data);
        setData(data); // Store the full data
  
        // Extract unique headings from SchoolDistribution
        if (data) {
          const headingsFromDistribution = Object.values(data)
            .filter((item) => item && item.Heading) // Ensure item is not null and has a Heading property
            .map((item) => item.Heading);
          const uniqueHeadings = [...new Set(headingsFromDistribution)];
          setHeadings(uniqueHeadings); // Set the unique headings
        }
  
        // Filter data based on the selected heading
        if (heading && data) {
          const filtered = Object.keys(data).reduce((acc, key) => {
            if (data[key] && data[key].Heading === heading) {
              acc[key] = data[key];
            }
            return acc;
          }, {});
          setFilteredData(filtered);
        } else {
          setFilteredData(data || {}); // If no heading is selected, show all data (or an empty object if data is null)
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [udiseNumber, heading]);

  const saveToIndexedDB = async (data) => {
    const db = await openDatabase();
    const transaction = db.transaction('inventory', 'readwrite');
    const store = transaction.objectStore('inventory');
  
    // Save the data to IndexedDB
    const request = store.put({
      key: 'instock',
      value: data // Save the array of items
    });
  
    return new Promise((resolve, reject) => {
      request.onsuccess = () => {
        resolve();
      };
  
      request.onerror = (event) => {
        reject(event.target.error);
      };
    });
  };
  
  const handlesave = async (event) => {
    event.preventDefault();
  
    if (!date || !material || !heading) {
      alert("Please fill in Date, Material, and Heading.");
      return;
    }
  
    setSaving(true);
    const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/inventory/instock.json`;
  
    try {
      // Fetch existing inventory data
      const response = await fetch(url, { method: 'GET' });
      let data = await response.json();
  
      // Ensure data is always an object, even if  returns null
      if (!data || typeof data !== 'object') {
        data = {};
      }
  
      let productId = null;
      let isNewProduct = true; // Flag to check if a new product ID should be created
  
      // Check if an entry with the same Heading exists
      for (const key in data) {
        if (data[key] && data[key].Heading === heading) {
          if (data[key].Material === material) {
            productId = key; // Found an existing product with the same Heading & Material
            isNewProduct = false;
            break;
          }
        }
      }
  
      // If no exact match (same Heading but different Material), create a new productId
      if (isNewProduct) {
        const existingEntries = Object.keys(data).filter(key => data[key] !== null);
        productId = (existingEntries.length > 0 ? Math.max(...existingEntries.map(Number))+1 : 1).toString();
        // Generate a new unique product ID
  
        // Create a new entry for this product
        data[productId] = { Material: material, Heading: heading, TotalQuantity: 0 };
      }
  
      // Ensure product entry exists
      if (!data[productId]) {
        data[productId] = { Material: material, Heading: heading, TotalQuantity: 0 };
      }
  
      // Determine the next available serial number
      const productEntry = data[productId];
      const serialKeys = Object.keys(productEntry)
        .filter(key => !['Material', 'Heading', 'TotalQuantity'].includes(key))
        .map(Number)
        .filter(num => !isNaN(num)); // Ensure only numeric keys are considered
  
      const nextSerialNo = serialKeys.length > 0 ? (Math.max(...serialKeys) + 1).toString() : "1";
  
      // Add new entry under the next serial number
      productEntry[nextSerialNo] = {
        date,
        ExpiryDate,
        PerItemAmount: peritem,
        Quantity: quantity,
        Remark: remark,
        VoucherNumber,
        provider,
        TotalAmount: tamount,
        BrandName: BrandName || " "
      };
  
      // Calculate total quantity for the product
      const totalQuantity = Object.values(productEntry)
        .filter(entry => typeof entry === 'object' && entry.Quantity)
        .reduce((sum, entry) => sum + Number(entry.Quantity), 0);
  
      // Update TotalQuantity field
      productEntry.TotalQuantity = totalQuantity;
  
      // Save updated data to 
      const updateResponse = await fetch(url, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
  
      if (updateResponse.ok) {
        // Save to IndexedDB
        await saveToIndexedDB(data); // Save the same data to IndexedDB
  
        setSaving(false);
  
        // Reset form fields
        setHeading('');
        setMaterial('');
        setEditingKey(null);
        setBrandName('');
        setExpiryDate('');
        setDate('');
        setprovider('');
        setVoucherNumber('');
        setQuantity('');
        setPerItem('');
        setTamount('');
        setRemark('');
        
        // Fetch updated data and update state
        const newResponse = await fetch(url, { method: 'GET' });
        const newData = await newResponse.json();
        setData(newData);
      } else {
        console.error('Error saving data:', updateResponse.statusText);
        setSaving(false);
      }
    } catch (error) {
      console.error('Error saving data:', error);
      setSaving(false);
    }
  };

const handleEdit = (key, serialNo) => {
  if (data[key] && data[key][serialNo]) {
    const selectedData = data[key][serialNo];
    setHeading(data[key].Heading);
    setMaterial(data[key].Material);
    setBrandName(selectedData.BrandName);
    setQuantity(selectedData.Quantity);
    setPerItem(selectedData.PerItemAmount);
    setTamount(selectedData.TotalAmount);
    setDate(selectedData.date);
    setExpiryDate(selectedData.ExpiryDate);
    setRemark(selectedData.Remark);
    setVoucherNumber(selectedData.VoucherNumber);
    setprovider(selectedData.provider);
    setEditingKey(key);
    setProductId(key);
    setSerialNo(serialNo);
    setIsUpdate(true);
  } else {
    console.error(`Invalid product ID or serial number: ${key} ${serialNo}`);
  }
};
  
const handleDelete = async (key, serialNo) => {
  const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/inventory/instock.json`;

  try {
    // Delete from 
    const response = await fetch(url, {
      method: 'GET',
    });

    const data = await response.json();

    if (data) {
      const updatedData = { ...data };
      if (updatedData[key] && updatedData[key][serialNo]) {
        const quantityToDelete = updatedData[key][serialNo].Quantity;
        delete updatedData[key][serialNo];

        // Update total quantity
        updatedData[key].TotalQuantity -= quantityToDelete;

        // If the product record is empty after deleting the serial number record, delete the product record
        if (Object.keys(updatedData[key]).filter(k => k !== 'Material' && k !== 'Heading' && k !== 'TotalQuantity').length === 0) {
          delete updatedData[key];
        }

        const updateResponse = await fetch(url, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updatedData),
        });

        if (updateResponse.ok) {
          // Delete from IndexedDB
          const db = await openDatabase();
          const transaction = db.transaction('inventory', 'readwrite');
          const store = transaction.objectStore('inventory');
          const request = store.get('instock');

          request.onsuccess = async (event) => {
            const result = event.target.result;
            if (result) {
              const updatedData = { ...result.value };
              if (updatedData[key] && updatedData[key][serialNo]) {
                delete updatedData[key][serialNo];

                // Update total quantity
                updatedData[key].TotalQuantity -= quantityToDelete;

                // If the product record is empty after deleting the serial number record, delete the product record
                if (Object.keys(updatedData[key]).filter(k => k !== 'Material' && k !== 'Heading' && k !== 'TotalQuantity').length === 0) {
                  delete updatedData[key];
                }

                const request = store.put({
                  key: 'instock',
                  value: updatedData
                });

                request.onsuccess = () => {
                  console.log('Data deleted from IndexedDB');
                };

                request.onerror = (event) => {
                  console.error('Error deleting data from IndexedDB:', event.target.error);
                };
              }
            }
          };

          request.onerror = (event) => {
            console.error('Error deleting data from IndexedDB:', event.target.error);
          };

          // Update state
          const response = await fetch(url, {
            method: 'GET',
          });
          const data = await response.json();
          setData(data);
        } else {
          console.error('Error deleting data:', updateResponse.statusText);
        }
      } else {
        console.error(`Invalid product ID or serial number: ${key} ${serialNo}`);
      }
    } else {
      console.error('No data found');
    }
  } catch (error) {
    console.error('Error deleting data:', error);
  }
};


const handleQuantityChange = (event) => {
  const value = event.target.value;
  setQuantity(value);

  // Calculate total amount only if peritem is set
  if (peritem) {
    const total = parseFloat(value) * parseFloat(peritem);
    setTamount(total);
  }
};

const handlePerItemChange = (event) => {
  const value = event.target.value;
  setPerItem(value);

  // Calculate total amount only if quantity is set
  if (quantity) {
    const total = parseFloat(quantity) * parseFloat(value);
    setTamount(total);
  }
};

const handlePrint = () => {
  const printContent = document.querySelector('.modal-content');

  if (printContent) {
    const cloneContent = printContent.cloneNode(true);

    // Modify the cloned content as needed
    const otherDetails = cloneContent.querySelectorAll('p'); 
    otherDetails.forEach((p, index) => {
      if (index !== 0) { 
        p.style.fontWeight = 'normal'; 
      }
    });

    // Call the function to remove the last column from the first table in the cloned content
    removeLastColumnOnPrint(cloneContent);

    const printWindow = window.open('', '', 'height=800,width=600');
    printWindow.document.write(`
      <html>
        <head>
          <style>
            @page {
              size: A4 Potrait;
              margin: 5mm;
              padding: 15px;
              border: 1px solid black;
            }
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 0;
            }
            table {
              border-collapse: collapse;
              width: 100%;
              font-size: 16px;
            }
            th, td {
              border: 1px solid black;
              text-align: center;
              padding: 5px;
            }
            td {
              font-size: 16px;
            }
            th {
              background-color:  rgb(166 214 245);
            }
            .print-button {
              display: none;
            }
            .school-header-container {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
            }
            .school-header2 {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              flex: 0 0 auto; /* Prevent this section from growing */
              margin-right: 10px;
            }
            .school-header2 img {
              max-height: 70px;
            }
            .school-header {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              text-align: center; margin-left:-70px;
              flex: 1 1 auto; /* This makes the school header take available space */
            }
            .school-header h1 {
              font-size: 28px;
              margin: 5px 0;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .school-header .report-title {
              font-size: 20px;
              margin: 5px auto;
              font-weight: bold;
              border: 1px solid black;
              width: 220px;
              padding: 5px;
              text-align: center;
              border-radius: 10px;
              background-color: black;
              color: white;
            }
            .school-header .report-tit {
              font-size: 16px;
              margin: 5px auto;
              font-weight: bold;
              text-align: center;
            }
          </style>
        </head>
        <body>
          <div class="school-header-container">
            <div class="school-header2">
              ${logoURL ? `<img src="${logoURL}" alt="School Logo" onload="window.print()">` : '<div></div>'}
            </div>
            <div class="school-header">
              <div style="margin-left: 15px;">
                <h1>${schoolName}</h1>
                <div class="report-tit">
                  ${language === 'English' ? 'Taluka' : 'तालुका'} ${taluka}, ${language === 'English' ? 'District' : 'जिल्हा'} : ${jilha}
                </div>
                <div class="report-title">
                  ${language === "English" ?  "Stock Inward Report" : "आवक साठा अहवाल"}
                </div>
              </div>
            </div>
          </div>
          <style>
            .styled-table {
              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
            }
          </style>
          ${cloneContent.outerHTML}
        </body>
      </html>
`);
    printWindow.document.close(); 

    // Call the function to append the last column back after printing
    appendLastColumnOnPrint(cloneContent);
    printWindow.focus(); // Focus the new window
    printWindow.print(); // Trigger print
    printWindow.close(); // Close the print window after printing
  } else {
    console.error('Print content not found');
  }
};


const handlePrintSpecific = (key) => {
  const productData = data[key];
  if (!productData) {
    alert("Product data not found!");
    return;
  }

  const printWindow = window.open('', '', 'height=600,width=800');
  printWindow.document.write(`
    <html>
      <head>
        <title>Print</title>
        <style>
          body { font-family: Arial, sans-serif; }
          table { border-collapse: collapse; width: 100%; }
          th, td { border: 1px solid black; padding: 8px; text-align: center; }
        </style>
      </head>
      <body>
        <h2 style="text-align: center;">Product Details</h2>
        <table style="width: 100%; margin-bottom: 20px;">
          <thead>
            <tr>
              <th colspan="9" style="border: 1px solid black; padding: 8px; text-align: center;">
                Product ID: ${key}, Category: ${productData.Heading || ''}, Material: ${productData.Material || ''}, Total Quantity: ${productData.TotalQuantity || ''}
              </th>
            </tr>
            <tr>                                                                                                                                                                                                                        
             <th>${language === "English" ? "Sr No" : "अनु. क्र"}</th>
              <th>${language==="English" ? "Brand" : "ब्रँड"}</th>
              <th>${language==="English" ? "Voucher Number" : "व्हाउचर क्रमांक"}</th>
              <th>${language==="English" ? "Provider": "पुरवणारा"}</th>
              <th>${language==="English" ? "Quantity":"प्रमाण"} </th>
              <th>${language==="English"? "Per Item Amount" :"रक्कम"}</th>
              <th>${language==="English"? "Total Amount" :"एकूण रक्कम"} </th>
              <th>${language==="English"? "Date" :"तारीख"} </th>
              <th>${language==="English"? "Expiry Date" :"अंतिम तारीख"} </th>
              <th>${language==="English"? "Remark" : "टिप्पणी"}</th>
            </tr>
          </thead>
          <tbody>
  `);

  // Loop through serial numbers
  Object.keys(productData).forEach(serialNo => {
    if (!['Material', 'Heading', 'TotalQuantity'].includes(serialNo)) {
      const serialData = productData[serialNo];
      printWindow.document.write(`
        <tr>
          <td>${serialNo}</td>
          <td>${serialData.BrandName || ''}</td>
          <td>${serialData.VoucherNumber || ''}</td>
          <td>${serialData.provider || ''}</td>
          <td>${serialData.Quantity || ''}</td>
          <td>${serialData.PerItemAmount || ''}</td>
          <td>${serialData.TotalAmount || ''}</td>
          <td>${serialData.date || ''}</td>
          <td>${serialData.ExpiryDate || ''}</td>
          <td>${serialData.Remark || ''}</td>
        </tr>
      `);
    }
  });

  printWindow.document.write(`
          </tbody>
        </table>
      </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.print();
};




function removeLastColumnOnPrint(cloneContent) {
  const tables = cloneContent.querySelectorAll('table'); // Get all tables in the cloned content
  tables.forEach(table => {
    const thead = table.querySelector('thead');
    const tbody = table.querySelector('tbody');

    const lastHeader = thead.querySelector('tr th:last-child');
    if (lastHeader) {
      lastHeader.style.display = 'none'; // Hide last column header
    }

    tbody.querySelectorAll('tr').forEach(row => {
      const lastCell = row.querySelector('td:last-child');
      if (lastCell) {
        lastCell.style.display = 'none'; // Hide last column data
      }
    });
  });
}

function appendLastColumnOnPrint(cloneContent) {
  const table = cloneContent.querySelector('table'); // Use the cloned content to find the table
  if (table) {
    const thead = table.querySelector('thead');
    const tbody = table.querySelector('tbody');

    const lastHeader = thead.querySelector('tr th:last-child');
    if (lastHeader) {
      lastHeader.style.display = '';
    }

    tbody.querySelectorAll('tr').forEach(row => {
      const lastCell = row.querySelector('td:last-child');
      if (lastCell) {
        lastCell.style.display = '';
      }
    });
  } else {
    console.error('Table not found in the cloned content');
  }
}

const uniqueHeadings = data ? [...new Set(Object.values(data).map((item) => item?.Heading))] : [];

 const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version
  
      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject("Error opening IndexedDB");
      };
  
      request.onsuccess = (event) => {
        resolve(event.target.result);
      };
  
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        
      };
    });
  };


 const fetchSchoolName = async () => {
    if (udiseNumber) {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['schoolData'], 'readonly');
        const objectStore = transaction.objectStore('schoolData');
        const request = objectStore.get(udiseNumber);

        request.onsuccess = (event) => {
          const schoolData = event.target.result;
          if (schoolData) {
            if (schoolData.schoolName) {
              setSchoolName(schoolData.schoolName);
            }
            if (schoolData.taluka) {
              setTaluka(schoolData.taluka);
            }
            if (schoolData.jilha) {
              setJilha(schoolData.jilha);
            }
            if (schoolData.schoolLogo) {
              setLogoURL(schoolData.schoolLogo);
            }
          }
        };

        request.onerror = (event) => {
          console.error("Error fetching school data:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching school data:', error);
      }
    }
  };

  useEffect(() => {
  fetchSchoolName();
}, [udiseNumber]);

  

useEffect(() => {
  const fetchProductData = async () => {
    if (productId) {
      try {
        const db = await openDatabase();
        const transaction = db.transaction('inventory', 'readonly');
        const store = transaction.objectStore('inventory');
        const request = store.get('instock');

        request.onsuccess = (event) => {
          const result = event.target.result;
          if (result && result.value) {
            const data = result.value;
            const productData = data[productId];
            if (productData) {
              setHeading(productData.Heading);
              setMaterial(productData.Material);
              setBrandName(productData.BrandName);
              setQuantity(productData.Quantity);
              setPerItem(productData.PerItemAmount);
              setTamount(productData.TotalAmount);
              setDate(productData.date);
              setRemark(productData.Remark);
              setprovider(productData.provider);
              setVoucherNumber(productData.VoucherNumber)
              setExpiryDate(productData.ExpiryDate)
              setEditingKey(productId);
            } else {
              setHeading('');
              setMaterial('');
              setBrandName('');
              setQuantity('');
              setPerItem('');
              setTamount('');
              setDate('');
              setRemark('');
              setprovider('');
              setExpiryDate('');
              setVoucherNumber('');
              setEditingKey(null); 
              alert("Product ID not found.");
              setProductId(''); 
            }
          } else {
            setHeading('');
            setMaterial('');
            setBrandName('');
            setQuantity('');
            setPerItem('');
            setTamount('');
            setDate('');
            setRemark('');
            setprovider('');
            setExpiryDate('');
            setVoucherNumber('');
            setEditingKey(null); 
          }
        };

        request.onerror = (event) => {
          console.error('Error fetching product data:', event.target.error);
        };
      } catch (error) {
        console.error('Error fetching product data:', error);
      }
    } else {
      setHeading('');
      setMaterial('');
      setBrandName('');
      setQuantity('');
      setPerItem('');
      setTamount('');
      setDate('');
      setRemark('');
      setprovider('');
      setExpiryDate('');
      setVoucherNumber('');
      setEditingKey(null); 
    }
  };

  fetchProductData();
}, [productId]);
     
const handleHeadingChange = (event) => {
  const selectedValue = event.target.value;
  if (selectedValue === "add-new-heading") {
    setShowPopup(true);
  } else {
    setHeading(selectedValue); // Set the selected heading
    setShowPopup(false); // Close the popup if an existing category is selected
  }
};

  return (
    <div className='main-content-of-page' style={{ padding: '20px' }}>
      <div style={{ border: '1px solid #ccc', width: '80%', margin: 'auto', marginTop: '10px', padding: '25px 30px ', borderRadius:'5px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}>
            
        <h3 style={{textAlign:'center',color:'#1B4332',fontWeight:'bold', marginBottom:'15px'}}>{language === "English" ? "Stock Inward" : "आवक साठा"}</h3>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
       
<div style={{ marginRight: '15px', width: '20%' }}>
      <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Category:" : "कॅटेगरी:"}</label>
      <div style={{ display: 'flex', alignItems: 'center' }}>
      <select
     value={heading}

onChange={handleHeadingChange}
    style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
     >
    <option value="">{language === "English" ? "Select Category" : "कॅटेगरी निवडा"}</option>
      {headings.map((heading, index) => (
     <option key={index} value={heading}>
    {heading}
    </option>
       ))}
     <option value="add-new-heading">{language === "English" ? "Add New Category" : "नवीन कॅटेगरी जोडा"}</option>
     </select>

        {showPopup && (
          <div className="modal1">
            <div className="modal-content minority-form">
              <div
                style={{
                  position: 'fixed',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  backgroundColor: 'white',
                  padding: '20px',
                  border: '1px solid #ccc',
                  borderRadius: '5px',
                  zIndex: 1000,
                }}
              >
                <button
                  style={{
                    position: 'absolute',
                    top: '-50px',
                    right: '-10px',
                    padding: '5px',
                    fontSize: '24px',
                    border: 'none',
                    backgroundColor: 'transparent',
                    color: 'red',
                  }}
                  onClick={() => setShowPopup(false)}
                >
                  <i className="fa-solid fa-xmark"></i>
                </button>
                <h6 className='text-center'>Add Category</h6>
                <input
                  type="text"
                  value={newHeading}
                  onChange={(event) => setNewHeading(event.target.value)}
                  style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
                  autoFocus
                />
                <button
                  style={{
                    marginLeft: '10px',
                    padding: '4px 10px',
                    fontSize: '16px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                    backgroundColor: 'Green',
                    color: 'White', float: 'right', marginTop: '10px',
                    textAlign:"center",
                    display:"block,",
                  }}
                  onClick={addNewHeading}
                >
                  Add
                </button>
              </div>
            </div>
      </div>
    )}


            </div>


          </div>
          {/* Rest of the code remains the same */}
          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Material" : "साहित्य"}</label>
            <input
              type='text'
              value={material}
              onChange={(event) => setMaterial(event.target.value)}
              placeholder='Enter Material'
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div>
{/* 
          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Class" : "वर्ग"}</label>
           
            <select id="classDropdown" value={selectedClass} onChange={handleClassChange} className="brown-dropdown dropdown" style={{ width: '100%', height:'35px'}}>
              <option value="">{language === "English" ? "Select" : "निवडा"}</option>
              

              {classOptions
  .filter(cls => cls !== null && cls !== undefined && cls !== '') // Filter out null and undefined classes
  .sort((a, b) => {
    const classA = a.split(' ')[1];
    const classB = b.split(' ')[1];
    let numA, numB;

    if (language === "English") {
      numA = romanToInt[classA] !== undefined ? romanToInt[classA] : 0; // Default to 0 if not found
      numB = romanToInt[classB] !== undefined ? romanToInt[classB] : 0; // Default to 0 if not found
    } else {
      numA = marathiToInt[classA] !== undefined ? marathiToInt[classA] : 0; // Default to 0 if not found
      numB = marathiToInt[classB] !== undefined ? marathiToInt[classB] : 0; // Default to 0 if not found
    }

    return numA - numB; // Sort based on the numerical value
  })
  .map((cls, index) => (
    <option key={index} value={cls}>
      {cls}
    </option>
  ))}
            </select>
          </div> */}
          
          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Brand name" : "ब्रँड नाव"}</label>
            <input
              type='text'
              value={BrandName}
              onChange={(event) => setBrandName(event.target.value)}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div>
          <div style={{  marginRight: '15px',width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Voucher number" : "व्हाउचर क्रमांक"}</label>
            <input
              type='text'
              value={VoucherNumber}
              onChange={(event) => setVoucherNumber(event.target.value)}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div>
       
          <div style={{  marginRight: '15px',width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Quantity" : "प्रमाण"}</label>
            <input
              type='text'
              value={quantity}
              onChange={handleQuantityChange}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Per Item Amount" : " रक्कम"}</label>
            <input
              type='number'
              value={peritem}
              onChange={handlePerItemChange}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div>

          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Total Amount" : "एकूण रक्कम"}</label>
            <input
              type='number'
              value={tamount}
              onChange={(event) => setTamount(event.target.value)}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div>
<div style={{  marginRight: '15px',width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Provider" : "पुरवणारा"}</label>
            <input
              type='text'
              value={provider}
              onChange={(event) => setprovider(event.target.value)}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div>
          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Date" : "तारीख"}</label>
            <input
              type='date'
              value={date}
              onChange={(event) => setDate(event.target.value)}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div>
           
          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Expiry Date" : "समाप्ती तारीख"}</label>
            <input
                  type='date'
                    value={ExpiryDate} // Use the new expiry date state
                    onChange={(event) => setExpiryDate(event.target.value)} // Update expiry date state
                   style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
             />
          </div>

          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Remark" : "टिप्पणी"}</label>
            <input
              type='text'
              value={remark}
              onChange={(event) => setRemark(event.target.value)}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div>
        </div>
        <div style={{
          textAlign: 'center'
        }}>
  <button type="button" onClick={isUpdate ? handleUpdate : handlesave} style={buttonStyle}>
    {isUpdate ? 'Update' : 'Save'}
  </button>

          <button type="button" onClick={handlePrint} style={buttonStyleReport}>
          {language === "English" ? "Print" : "प्रिंट "}
        </button>
    
        </div>
      </div>

      {showModal && (
  <div style={{
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '10px',
    width: '100%',
    maxWidth: '1200px',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.7)',
    maxHeight: '100%',
    position: 'relative', margin: '40px auto'
  }}>

    <div className="modal-content p-3" style={{ border: '1px solid black' }}>
      <h5 className='h3classforschol' style={{ textAlign: 'center', color: '#1B4332', fontWeight: 'bold', marginBottom: '5px' }}>{language === "English" ? "Stock Inward" : "आवक साठा"}</h5>
      <table style={{
        width: '100%',
        borderCollapse: 'collapse',
        marginBottom: '30px',
        fontFamily: 'Arial, sans-serif',
        border: '1px solid black',
        borderRadius: '10px',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
      }}>
        <thead>
          <tr >
            <th className='firthtd' style={{ fontWeight: 'bold', border: '1px solid black', padding: '6px 4px', textAlign: "center" }}>Product ID</th>
            <th style={{ fontWeight: 'bold', border: '1px solid black', padding: '6px 5px', textAlign: "center" }}>{language === "English" ? "Category" : "कॅटेगरी"}</th>
            <th style={{ fontWeight: 'bold', border: '1px solid black', padding: '6px 5px', textAlign: "center" }}>{language === "English" ? "Material" : "साहित्य"}</th>
            <th style={{ fontWeight: 'bold', border: '1px solid black', padding: '6px 5px', textAlign: "center" }}>{language === "English" ? "Total Quantity" : "एकूण प्रमाण"}</th>
            <th style={{ fontWeight: 'bold', border: '1px solid black', padding: '6px 5px', textAlign: "center" }}><i className="fa-solid fa-caret-down"></i></th>
        
          </tr>

          
        </thead>
        <tbody>
        {data &&
  Object.keys(data)
    .filter((key) => data[key] && key !== "0")
    .filter((key) => {
      const item = data[key];
      return (
        item &&
        (item.Material ||
          item.BrandName ||
          item.VoucherNumber ||
          item.provider ||
          item.Quantity ||
          item.PerItemAmount ||
          item.TotalAmount ||
          item.date ||
          item.ExpiryDate ||
          item.Remark)
      );
    })
    .map((key, index) => {
      // Determine if the current row is the clicked row or the expanded row
      const isOpenRow = openRow === key;

      return (
        <React.Fragment key={index}>
          <tr className={isOpenRow ? 'grouped-row' : ''}>
            <td style={{ border: "1px solid black", padding: "6px" }}>{key}</td>
            <td style={{ border: "1px solid black", padding: "6px" }}>{data[key]?.Heading}</td>
            <td style={{ border: "1px solid black", padding: "6px" }}>{data[key]?.Material}</td>
            <td style={{ border: "1px solid black", padding: "6px" }}>{data[key]?.TotalQuantity}</td>
            <td style={{ border: "1px solid black", padding: "6px", textAlign: "center" }}>
              <button
                style={{
                  padding: "5px",
                  fontSize: "16px",
                  border: "none",
                  backgroundColor: "blue",
                  color: "white",
                  transform: isOpenRow ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.5s",
                  cursor: "pointer",
                }}
                onClick={() => toggleRow(key)}
              >
                <i className="fa-solid fa-caret-down"></i>
              </button>
              <button
                style={{
                  padding: "5px",
                  fontSize: "16px",
                  border: "none",
                  backgroundColor: "orange",
                  color: "white",
                  marginLeft: "10px",
                  cursor: "pointer",
                }}
                onClick={() => handlePrintSpecific(key)} // Call the print function with the product ID
              >
                <i className="fa-solid fa-print"></i>
              </button>
            </td>
          </tr>

          {isOpenRow && (
            <tr className='grouped-row'>
              <td colSpan="5" style={{ padding: "0px", width: "100%" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", border: "none" }}>
                  <thead>
                    <tr className='instock-tr grouped-row'> {/* Apply the same class here */}
                      <th style={{ border: "1px solid #ccc", padding: "6px", textAlign: "center", width: "10%", fontWeight: '600' }}>
                        {language === "English" ? "Sr No" : "अनु. क्र"}
                      </th>
                      <th style={{ border: "1px solid #ccc", padding: "6px", textAlign: "center", width: "10%", fontWeight: '600' }}>
                        {language === "English" ? "Brand" : "ब्रँड"}
                      </th>

                      <th style={{ border: "1px solid #ccc", padding: "6px", textAlign: "center", width: "10%", fontWeight: '600' }}>
                        {language === "English" ? "Voucher Number" : "व्हाउचर क्रमांक"}
                      </th>
                      <th style={{ border: "1px solid #ccc", padding: "6px", textAlign: "center", width: "10%", fontWeight: '600' }}>
                        {language === "English" ? "Provider" : "पुरवणारा"}
                      </th>
                      <th style={{ border: "1px solid #ccc", padding: "6px", textAlign: "center", width: "10%", fontWeight: '600' }}>
                        {language === "English" ? "Quantity" : "प्रमाण"}
                      </th>
                      <th style={{ border: "1px solid #ccc", padding: "6px", textAlign: "center", width: "10%", fontWeight: '600' }}>
                        {language === "English" ? "Per Item Amount" : "रक्कम"}
                      </th>
                      <th style={{ border: "1px solid #ccc", padding: "6px", textAlign: "center", width: "10%", fontWeight: '600' }}>
                        {language === "English" ? "Total Amount" : "एकूण रक्कम"}
                      </th>
                      <th style={{ border: "1px solid #ccc", padding: "6px", textAlign: "center", width: "10%", fontWeight: '600' }}>
                        {language === "English" ? "Date" : "तारीख"}
                      </th>
                      <th style={{ border: "1px solid #ccc", padding: "6px", textAlign: "center", width: "10%", fontWeight: '600' }}>
                        {language === "English" ? "Expiry Date" : "अंतिम तारीख"}
                      </th>
                      <th style={{ border: "1px solid #ccc", padding: "6px", textAlign: "center", width: "10%", fontWeight: '600' }}>
                        {language === "English" ? "Remark" : "टिप्पणी"}
                      </th>
                      <th style={{ border: "1px solid #ccc", padding: "6px", textAlign: "center", width: "10%", fontWeight: '600' }}>
                        {language === "English" ? "Action" : "कृती"}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(data[key])
                      .filter((serialNo) => !['Material', 'Heading', 'TotalQuantity'].includes(serialNo))
                      .map((serialNo, index) => (
                        <tr key={index}>
                          <td style={{ border: "1px solid #ccc", padding: "6px", width: "10%" }}>{serialNo}</td>
                          <td style={{ border: "1px solid #ccc", padding: "6px", width: "10%" }}>{data[key][serialNo]?.BrandName}</td>
                          <td style={{ border: "1px solid #ccc", padding: "6px", width: "10%" }}>{data[key][serialNo]?.VoucherNumber}</td>
                          <td style={{ border: "1px solid #ccc", padding: "6px", width: "10%" }}>{data[key][serialNo]?.provider}</td>
                          <td style={{ border: "1px solid #ccc", padding: "6px", width: "10%" }}>{data[key][serialNo]?.Quantity}</td>
                          <td style={{ border: "1px solid #ccc", padding: "6px", width: "10%" }}>{parseFloat(data[key][serialNo]?.PerItemAmount || 0).toFixed(1)}</td>
                          <td style={{ border: "1px solid #ccc", padding: "6px", width: "10%" }}>{parseFloat(data[key][serialNo]?.TotalAmount || 0).toFixed(1)}</td>
                          <td style={{ border: "1px solid #ccc", padding: "6px", width: "10%" }}> {data[key][serialNo]?.date ? formatDate(data[key][serialNo]?.date) : "-"}</td>
                          <td style={{ border: "1px solid #ccc", padding: "6px", width: "10%" }}>{data[key][serialNo]?.ExpiryDate ? formatDate(data[key][serialNo]?.ExpiryDate) : "-"}</td>
                          <td style={{ border: "1px solid #ccc", padding: "6px", width: "10%" }}>{data[key][serialNo]?.Remark}</td>
                          <td style={{ border: "1px solid #ccc", padding: "6px", width: "10%" }}>
                            <button
                              style={{
                                padding: '5px',
                                fontSize: '16px',
                                border: 'none',
                                backgroundColor: 'blue',
                                color: 'white',
                                marginRight: '10px',
                              }}
                              onClick={() => handleEdit(key, serialNo)} // Call the edit function with the serial number
                            >
                              <i className="fa-solid fa-pen-to-square"></i>
                            </button>
                            <button
                              style={{
                                padding: '5px',
                                fontSize: '16px',
                                border: 'none',
                                backgroundColor: 'red',
                                color: 'white',
                              }}
                              onClick={() => handleDelete(key, serialNo)}
                            >
                              <i className="fa-solid fa-trash-can"></i> 
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </td>
            </tr>
          )}
        </React.Fragment>
      );
    })}
   
      </tbody>
      <style jsx>{` 
  thead th{
    background-color: rgb(200 211 217 / 41%) !important;
    border: 1px solid black;
  } 
    td{
    border: 1px solid black;
  }  
  /* Add this CSS to your styles */
.grouped-row {
  background-color: rgba(187, 214, 248, 0.4)  !important;
  border: 1px solid rgb(166, 214, 245) ;
  boxShadow
}
`} </style>
      </table>
    </div>
  </div>
)}

</div>

  );
}

export default Instock;

const buttonStyleReport= {
  marginTop: '20px',
  padding: '8px 16px',
  fontSize: '14px',
  backgroundColor: '#d4a017',
  color: '#fff',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  marginLeft:'20px',
  right:'0',
  float:'right'
}
const buttonStyle = {
  marginTop: '20px',
  padding: '8px 20px',
  fontSize: '14px',
  backgroundColor: '#4CAF50',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer'
};